import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, roles }) {
    const { user, loading } = useAuth();
    if (loading || user === null)
        return (
            <div className="min-h-screen flex items-center justify-center bg-background">
                <Loader2 className="h-8 w-8 animate-spin text-primary" />
            </div>
        );
    if (!user) return <Navigate to="/login" replace />;
    if (roles && !roles.includes(user.role) && !["owner", "super_admin"].includes(user.role))
        return <Navigate to="/dashboard" replace />;
    return children;
}
